import { CourseType } from '../../../types'
import { getCourseLessons } from './getCourseLessons'

export const getCourseLessonCount = (course: CourseType) => {
  const allLessons = getCourseLessons(course)
  return allLessons.length
}
